import { Component, inject, OnInit } from '@angular/core';
import {
  DocumentsComponent,
  Document,
  Customer,
  AuthService,
  SelectedCustomerService
} from 'gung-standard';
import { GungUser as User } from 'gung-standard';
import { forkJoin, Observable } from 'rxjs';
import { filter, first, map } from 'rxjs';

@Component({
    selector: 'tylo-documents-list',
    templateUrl: './tylo-documents-list.component.html',
    styleUrls: ['./tylo-documents-list.component.css'],
    standalone: false
})
export class TyloDocumentsListComponent extends DocumentsComponent {
  protected authService = inject(AuthService);
  protected selectedCustomerService = inject(SelectedCustomerService);

  protected getAllDocuments(nocache?: boolean): Observable<Document[]> {
    return forkJoin({
      user: this.authService.getCurrentUser().pipe(first()),
      documents: super.getAllDocuments(nocache).pipe(first()),
      customer: this.selectedCustomerService.getSelectedCustomer().pipe(
        filter(customer => !!customer),
        first()
      )
    }).pipe(
      first(),
      map(({ user, documents, customer }) => {
        return documents.filter(
          doc =>
            doc.metaData &&
            doc.metaData.inMenu &&
            (doc.metaData.inMenu === 'true' || doc.metaData.showInDocumentView === 'true') &&
            this.showDocumentExt(doc, user, customer)
        );
      })
    );
  }

  showDocumentExt(document, user: User, customer: Customer): boolean {
    let result = false;
    if (document && document.metaData && document.metaData.userGroups) {
      const currentUserKeys = Object.keys(user.activeGroups).filter(userGroup => user.activeGroups[userGroup] === true);
      if (document.metaData && document.metaData.userGroups && typeof document.metaData.userGroups === 'string') {
        document.metaData.userGroups = JSON.parse(document.metaData.userGroups);
      }
      const documentKeys = Object.keys(document.metaData.userGroups).find(
        userGroup => document.metaData.userGroups[userGroup] === true
      );
      const groupKey = Object.keys(document.metaData.userGroups).find(
        userGroup => document.metaData.userGroups[userGroup] === true && currentUserKeys.some(key => key === userGroup)
      );
      if (groupKey) {
        result = true;
      } else {
        result = false;
      }

      if (document.metaData.includedAssortments) {
        const assortmentList: string[] = document.metaData.includedAssortments.split(',');
        if (!assortmentList.includes(user.assortment)) {
          return false;
        }
      }
      if (!customer) {
        return false;
      }
      if (document.metaData.includedCustomers) {
        const customerList: string[] = document.metaData.includedCustomers.split(',');
        if (!customerList.includes(customer.id)) {
          return false;
        }
      }
      if (document.metaData.excludedCustomers) {
        const customerList: string[] = document.metaData.excludedCustomers.split(',');
        if (customerList.includes(customer.id)) {
          return false;
        }
      }
    }
    return result;
  }
}
